import { CachedBulkFetchService } from '../bulkFetch/abstractBulkFetch.service';
import httpService from '../http/http.service';
import KeyBy from 'lodash-es/keyBy';
import { UsernameViewModel, UsernamesRequest, UsernameViewObject } from '@/types/apiServerContract';

class UsernameSService extends CachedBulkFetchService<UsernameViewObject> {
    constructor(protected controller: string) {
        super(controller);
    }

    protected async apiCall(ids: string[]): Promise<{ [key: string]: UsernameViewObject }> {
        const request: UsernamesRequest = {
            userIds: ids,
            accountIds: []
        };
        const result = await httpService.Post<UsernameViewModel>(this.getUrl('GetUsernamesById'), request);
        return KeyBy<UsernameViewObject>(result.data, 'userId');
    }

    public async getUsername(id: string): Promise<string> {
        const item = await this.getCachedItem(id);
        return item.username;
    }
}

class UsernameNService extends CachedBulkFetchService<UsernameViewObject> {
    constructor(protected controller: string) {
        super(controller);
    }

    protected async apiCall(ids: number[]): Promise<{ [key: number]: UsernameViewObject }> {
        const request: UsernamesRequest = {
            accountIds: ids,
            userIds: []
        };
        const result = await httpService.Post<UsernameViewModel>(this.getUrl('GetUsernamesByAccountId'), request);
        return KeyBy<UsernameViewObject>(result.data, 'accountId');
    }

    public async getUsername(id: number): Promise<string> {
        const item = await this.getCachedItem(id);
        return item.username;
    }
}

export default class ProfileService {
	public static getUsernameByUserId = new UsernameSService('user');
	public static getUsernameByAccountId = new UsernameNService('user');
}
